<template>
  <div style="padding: 0 8.3vw">
  <a-row type="flex" v-if="employee.operation[0]">
    <a-col class="team_employee" v-for="(item, index) in employee.operation"
           v-on:mouseover="employee.operation[index].active = true"
           v-on:mouseleave="employee.operation[index].active = false"
           :key="index">
      <img :src="item.picture" class="image">
      <h1 class="team_employee_name" v-if="employee.operation[index].active">{{ employee.operation[index].name }}</h1>
    </a-col>
  </a-row>
  </div>
</template>

<script>
import axios from "axios";
import {reactive, onMounted} from 'vue'

export default {
  name: 'Team_operation',
  setup() {
    let employee = reactive({
      operation: [],
    })

    onMounted(() => {
      axios.get('https://sig-china.com:8081/api/employee/operation')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {

              employee.operation.push(res.data[i])

            }
            employee.operation.sort((a, b) => {
              return a['id'] - b['id']
            })
            for (let i = 0; i < employee.operation.length; i++) {
              employee.operation[i]['picture'] = 'https://sig-china.com' + employee.operation[i]['picture']
              employee.operation[i].active = false
            }
          })
    })

    return {employee}
  }
}
</script>

<style scoped>
.team_employee {
  width: auto;
  height: auto;
  align-items: center;
  justify-content: center;
  max-width: 20.8vw;
  position: relative;
}

.image {
  width: 20.8vw;
  height: auto;
  max-width: 20.8vw;
}

.team_employee_name {
  z-index: 2;
  position: absolute;
  bottom: 3vh;
  left: 2vw;
}

.image:hover {
  opacity: 0.5;
}

</style>
